/*
 * @Author: lzh
 * @Date: 2022-09-15 11:29:01
 * @LastEditors: lbh
 * @LastEditTime: 2025-08-20 12:29:42
 * @Description: file content
 */
const zh = {
  语言: "简体中文",
  name: "姓名",
  info: {
    age: "男",
  },
  "Queue System": "排乜Queue",
  "Getting the number online and receiving notice":
    "云端取号轮候,轮到你还有用餐提醒哦",
  "Welcome Guest": "欢迎访客",
  "Log in for queuing details via Phone number": "手机号码登录随时掌握轮候动态",
  "Sign in_": "请登入",
  Queue: "轮候取号",
  "Currently queuing": "现在轮候号码数",
  "Sorry, there is a temporarily suspension of queue service. Please contact the restaurant staff":
    "不好意思，当前餐厅已暂停取号服务。如有疑问，请与餐厅服务员联系",
  "Get number": "取号",
  "Enter your phone number": "电话识别",
  "Enter your last 4-digits of phone number_": "请输入电话后四位以便识别",
  "Party size": "用餐人数",
  Confirm: "确定",
  Next: "下一步",
  Cancel: "取消",
  Previous: "返回",
  people: "人",
  awaitPeople: {
    key: "等待 {x} 桌",
  },
  Continue: "继续轮候",
  "Whatsapp for queue status": "用WhatsApp通知你轮候最新动态",
  Notice: "确认通知",
  call_Number: "用餐号",
  call_Current: "当前呼叫",
  call_tables: "桌",
  Waiting: "还需等候",
  "Currently queuing": "现在轮候号码数",
  Restaurant: "餐厅名称",
  Address: "餐厅地址",
  "Order time": "取号时间",
  "You'll be there soon": "请注意轮候动态，很快就到你啦",
  "Cancel line up": "取消轮候",
  "Take number": "重新取号",
  "again Take number": "再次取号",
  "Getting number successfully": "取票成功",
  "WhatsApp prompts the latest trends of queuing": "用WhatsApp提示轮候最新动态",
  "Save credentials": "将轮候号码保存到你的手机上册,避免号码遗失",
  Confirm_: "确认",
  promptlySave: "立即保存",
  "Are you sure you want to cancel your queue number?": "真的要取消轮候吗",
  "It's time to eat!": "很快就有得吃啦！",
  beingQueuing: "排队中",
  call_Calling: "叫号中",
  callPassed: "已过号",
  callSeated: "已入座",
  callCancelled: "已取消",
  awaitXToYour_: {
    key: "*还有 {X} 位就到你啦！",
  },
  "The number has expired, please get it again": "号码已失效，请重新取号",
  "Unable to access the page, please check the link for errors":
    "链接已失效，请检查后再试",
  "Unable to access the page, please try again": "改链接已失效，请重新扫码",
  "You have confirmed": "當前賬戶已經完成訂閲，請留意通知!",
  "Sign in and receiving WhatsApp Message": "立即登录, 即可获取会员权益",
  "phone number": "手机号码",
  "Please enter the phone number": "请输入手机号码",
  "I have read and agreed": "我已阅读并同意",
  "Take number succeeded": "取号成功提示",
  "Have dinner": "用餐号",
  "Screenshot to save the number": "为免遗失，请将号码<br/>截图保存到相册",
  "will be coming soon": "请注意轮候动态，好快到你啦！",
  "Enter your last 4-digits of phone number": "请输入手机号后四位",
  "Enter a correct Phone Number": "请输入有效的手机号码!",
  "Failed to get the number, please try again": "取号失败，请联系工作人员",
  "There are active numbers": "您已取过号",
  "Line up the details": "轮候详情",
  "No order at present": "暂时没有订单",
  "No Data": "暂无数据",
  combo: {
    "Select x": "请选择 {X} 项",
    "Select x~y": "请选择 {X}~{Y} 项",
    "Select at least x": "请至少选 {X} 项",
    "x Selected": "已选 {X} 项",
    Required: "必选",
    total: "总计",
    confirm: "确认",
    请至少选x项: "请至少选 {x} 项",
    加配食品: "加配食品",
    停: "停",
  },

  shop: {
    Address: "地址",
    Number: "电话",
    "Special Offer": "餐厅优惠",
    More: "更多",
    "Please select address": "请选择地址",
    OK: "知道了",
    "Click the button in the upper right corner": "点击右上角的「…」按钮",
    'Select"Open in browser"': "选「在浏览器中打开」",
    "Open in browser": "在浏览器中打开",
    Terms: "使用条款",
    "Privacy Policy": "私隐政策",
    "© 2022 Gingersoft Limited.All rights reserved.No reproduction allowed.":
      "© 2022姜软件有限公司Gingersoft.版权所有不得转载",
    "X Sold": "{X}人购买",
    "X Redeemed": "{X}人领取",
    "X Redeemed2": "已领{X}",
    More2: "点击查看更多",
    Redeemed: "已领取",
    "Use Now": "去使用",
    "Sold Out": "已售罄",
    Upcoming: "待开始",
    "Redeem Now": "立即领取",
    Details: "查看详情",
    "Sold Out": "已售罄",
    "Available Restaurants": "适用餐厅",
    "Business Hours": "营业时间",
    Order: "我的订单",
    Coupon: "我的优惠券",
    Bookmark: "我的收藏",
    Language: "选择语言",
    Logout: "注销",
    Login: "未登录",
    "Failed to obtain address!": "获取地址失败！",
    Delivery: "外送",
    "Self pick up": "自取",
    "Cold Chain Delivery": "冻链派送",
    "No available restaurants!": "暂无可用餐厅!",
    Success: "领取成功",
    "Please go to my account-coupons to check": "请前往我的帐户-优惠券中查看",
  },
  orderDetail: {
    "Payment Method:": "支付方式：",
    "Payment Method": "支付方式",
    "Use Now": "使用优惠券",
    "Service Fee:": "服务费：",
    "Bill Decimal:": "账单小数：",
    "Total X items": "共{X}份",
    Total: "总金额：",
    "Pay the remaining time": "支付剩余时间", //支付剩余时间
    Order: "订单",
    createTime: "时间",
    "Service amount": "服务费：",
    "Bill Decimal": "账单小数：",
    "Invite details": "自取详情",
    package_detail: "套票详情", // Details
    "Order cancelled": "订单已取消",
    "Go to view": "前往查看",
    "Order Details": "订单详情", //訂單詳情
    "Order No": "订单编号",
    "Solitary time": "落单时间", //落單時間
    Reminder: "温馨提示",
    // ! 2023-10-31
    Reminder: "温馨提示",
    QRCode: "固定码详情",
    StoreOrder: "店铺订单详情",
    SkyOrder: "扫码点餐详情",
    PriorOrder: "预点餐详情",
    UsedCoupon: "使用优惠券",
    "Member Discounts": "会员等级折扣",
    "Restaurant Discounts": "餐厅折扣",
    "Automatic Discounts": "自动折扣",
    Coupons: "优惠券",
    Wait: "等待支付",
    "Payment completed": "支付完成",
    Remaining: "剩余",
    "Coupons have been distributed": "优惠券已发放",
    'Location: HomePage → "..." in the upper right corner → My coupons':
      "存放在：首页 → 右上角“...” → 我的优惠券",
    Details: "查看明细",
    "View more discounts：Ricepon App -> Coupon":
      "更多优惠请至 饭团APP-优惠券 查看",
    "Please complete payment within X minutes":
      "{X}分钟内未支付，订单将自动取消",
    "Save screenshot to photo album": "截屏将优惠券保存到手机",
    "so you won’t lose it.": "避免优惠券丟失",
    "Save coupon to album": "保存优惠券到你的相册",
    "Save coupon to album2": "保存优惠券到相册",
    "Copied successfully": "复制成功",
    "The browser doesn’t support auto-copy.": "当前浏览器不支持自动复制",
    "QR code": "二维码",
    Paid: "已支付",
  },
  myCoupon: {
    "My coupon": "我的优惠券",
    Coupon: "我的优惠券",
    Available: "可使用",
    "Please enter the discount code to redeem": "请输入优惠码兑换",
    Used: "已使用",
    Expired: "已过期",
    "Redemption successful": "已成功领取优惠券",
    "Check coupon status via WhatsApp": "通过WhatsApp查看优惠券状态",
    Cancel: "取消",
    to: "至",
    price: "金额",
  },
  couponDetail: {
    "Valid Min order of HK$X": "满{X}可用",
    "X Sold": "{X}人购买",
    "X Redeemed": "{X}人领取",
    "X Redeemed2": "已领{X}",
    "Includes X Coupons": "内含{X}张优惠券",
    "All shop": "所有门店适用",
    "Only designated shop": "指定门店适用",
    "Valid until:": "有效期：",
    "Available X days": "购买后{X}天内可用",
    "More Coupon": "更多优惠券",
    "Valid until2:": "套票有效期",
    "Terms and Conditions": "条款及细则",
    "More Terms and Conditions": "更多条款及细则",
    "Valid until3:": "优惠券有效期",
    "Available X days": "领取后{X}天可用",
    "Related offers": "相关优惠",
    "Only X coupons left": "仅剩{X}张",
    Redeemed: "已领取",
    "Use Now": "去使用",
    "Sold Out": "已售罄",
    "Redeem Now": "立即领取",
    "Welcome Offer": "迎新优惠",
    "Join Member": "加入会员",
    Buy: "购买",
    "X Shop Available": "查看{X}家可用分店",
    "No address": "暂无地址信息！",
    "By placing your order,you agree to the Terms and Conditions":
      "购买即表示您已细阅并同意",
    "Event Terms of Service": "活动服务条款",
    "I have read and agree X & Y": "我已阅读并同意《{X}》及{Y}",
    "I have read and agree": "同意并阅读",
    Confirm: "确认",
    Back: "返回",
  },
  refresh: {
    refreshUp: "下拉可以刷新", //下拉可以刷新
    "Release refresh": "释放立即刷新", //釋放立即刷新
    Refreshing: "正在刷新...", //正在刷新...
    "Successfully loaded": "加载成功",
    "Pull-up shows more": "上拉显示更多", //上拉顯示更多
    "Loading...": "正在加载...", //正在加載
    "No more data": "没有更多数据了", //沒有更多數據了
  },
  myAddress: {
    "Add address": "添加地址",
  },
  message: {
    "Collection successful": "收藏成功!",
    "Canceled favorites": "取消成功!",
    and: "及",
    selfBrand: "本品牌",
    "Brand Agreement": "品牌协议",
    "Ricepon Agreement": "Ricepon协议",
    Loading: "加载中...",
  },
  login: {
    "Bind mobile number": "绑定手机号码",
    "Successful SMS Sending!": "短信发送成功!",
    "Binding success!": "绑定成功!",
    "Enter a correct Phone Number": "请输入正确的手机号码",
    "Phone number": "请输入手机号码",
    "Enter verification code": "请输入验证码",
    "Send verify code": "取得验证码",
    "phone number2": "手机号码",
    Captcha: "验证码",
    Confirm: "确认",
    "SMS verification code error": "短信验证码错误!",
    "Member login error times too many, please try again later":
      "会员登录错误次数太多,请稍后重试!",
    "Your account has been suspended, please contact customer service email!":
      "账户已停止,请联络客户服务email!",
    "Network request timeout! Please refresh and try again!":
      "网络请求超时!请刷新后重试!",
    "Your account hasexpired, please contact customer service email!":
      "账户已过期，请联络客户服务email!",
    "Binding Mobile Phone Number": "绑定手机号",
    "phone number 2": "手机号",
    "Phone number": "请输入手机号",
    bindSuccess: "绑定成功!",
    Back: "返回",
    Agree: "同意",
    googleBindTitle: "绑定 Google 账号",
    googleBindSubtitle:
      "麻烦你先绑定一次，之后就可以直接用 Google 登录，不用再收短信验证码。",
    googleBindAccountName: "Google 账号",
    googleBindAccountLinked: "Google 账号已关联",
    googleBindWithSms: "短信绑定",
    googleBindWithPassword: "密码绑定",
    googleBindPasswordLabel: "密码",
    googleBindPasswordPlaceholder: "请输入密码",
    googleBindHelpTitle: "需要帮助？",
    googleBindHelpText:
      "如果你已设置密码，可直接使用密码绑定；如果未注册或未设置密码，也可以使用短信方式完成注册或绑定。",
    googleBindExpired: "Google 绑定已失效，请重新登录 Google",
    googleBindInvalidPhone: "请输入正确的手机号",
    googleBindPasswordRequired: "请输入密码",
    googleBindFailed: "Google 绑定失败",
    googleBindPasswordFailed: "密码绑定失败",
    googleBindSuccess: "绑定成功",
    googleBindContinue: "继续",
    googleBindBusy: "操作过于频繁，请稍后再试",
    googleMemberNotFound: "未找到会员资料，请稍后再试",
    googleAccountAlreadyBound: "该 Google 账号已绑定其他账号",
    googleMemberAlreadyBoundOther: "该会员已绑定另一个 Google 账号",
    googleLoginFailed: "Google 登录失败",
    googleLoginFailedRetry: "Google 登录失败，请改用密码或短信登录",
    googleLoginUnavailable: "Google 登录暂时不可用",
    googleOpenInBrowser:
      "当前页面所在浏览器不支持 Google 登录，请点击右上角用系统浏览器打开后再试",
    googleNeedAgree: "请先同意条款",
    googleAgreeAndContinue: "需要先同意条款，是否同意并继续 Google 登录？",
    googleAgreeAndContinuePrefix: "是否同意",
    googleAgreeAndContinueSuffix: "并继续 Google 登录？",
    googleClientIdTip: "配置 VUE_APP_GOOGLE_CLIENT_ID 后即可使用 Google 登录。",
    googleRecommended: "推荐使用 Google 登录",
    googleRecommendedDesc: "无需等待短信，登录和绑定会更快完成。",
    googleButtonLabel: "使用 Google 账号登录",
    Use_Google_or_WhatsApp_to_log_in_quickly: "使用 Google 或 WhatsApp 快速登录",
    Use_WhatsApp_to_log_in: "使用 WhatsApp 登录",
    SMS_login: "短信登录",
    WhatsApp_login_register: "WhatsApp登录/注册",
    Enter_WhatsApp_phone_number: "请输入 WhatsApp 手机号",
    Enter_WhatsApp_verification_code: "请输入 WhatsApp 验证码",
    googleConfirmTitle: "Google登录/注册",
    googleConfirmSubtitle: "同意协议并使用Google授权登录",
    googleConfirmCancel: "再想想",
    googleConfirmAgree: "我同意",
    googleAltLogin: "或使用短信登录",
    googleLoading: "正在加载 Google 登录…",
    googleRedirecting: "正在跳转到 Google…",
    bindMobileDescription: "使用WhatsApp快速登录",
    unregisteredAutoRegister: "未注册手机号将自动创建账号",
    smsLoginLabel: "短信登录",
    passwordLoginLabel: "密码登录",
    loginActionText: "登录",
    whatsappVerifyLogin: "WhatsApp 验证登录",
    safeAuthTip: "快速、安全、一键授权",
    passwordSafeTip: "使用密码安全登录",
    switchOtherMethods: "或切换其他方式",
    forgotPasswordLabel: "忘记密码?",
    pasteOtpConfirm: "是否粘贴{code}?",
    nextStep: "下一步",
    registerLogin: "注册/登录",
    welcomeTo: "欢迎来到",
    memberRewardsTip: "成为会员储积分，尊享优惠~",
    passwordLogin: "密码登录",
    smsLogin: "验证码登录",
    forgotPassword: "忘记密码?",
    pleaseEnterPassword: "请输入密码",
    pleaseAgreeAgreement: "请同意协议",
    loginSuccess: "登录成功",
    retrievePassword: "找回密码",
    forgotPasswordPrompt: "忘记密码？可以通过电话号码找回哦!",
    setPassword: "设置密码",
    pleaseSetPassword: "请设置密码",
    confirmPassword: "确认密码",
    pleaseConfirmPassword: "请确认密码",
    phoneIncorrect: "手机号不正确",
    passwordsNotMatch: "密码不一致",
    passwordResetSuccess: "密码重置成功",
    passwordResetFailed: "密码重置失败",
    next: "下一步",
    step2SetPassword: "2/3 设置密码以便后续登录",
    passwordLengthGt6: "密码长度需大于6位",
    confirmPasswordNotMatch: "确认密码与密码不一致",
    completeRegistration: "完成注册",
    completeProfile: "完善个人资料",
    step3CompleteProfile: "3/3 完善个人资料，获得更好的服务~",
    memberName: "会员名称",
    pleaseEnterMemberName: "请输入会员名称",
    gender: "性别",
    male: "男",
    female: "女",
    birthday: "出生日期",
    pleaseSelectBirthday: "请选择出生日期",
    pleaseEnterEmail: "请输入邮箱地址",
    selectDate: "选择年月日",
    pleaseSelectGender: "请选择性别",
    networkRetryLogin: "网络开小差了,请重试登录!",
    registrationExpired: "注册信息已过期,请重新注册!",
    updateProfileSuccess: "修改信息成功",
    welcomeBack: "欢迎回来",
    platformPoweredByRicepon: "本平台由饭团Ricepon提供技术支持",
    riceponAccountSyncDesc:
      "检测到您已是 饭团Ricepon 的用户，为让您快速开始，我们将为您同步账户资讯。",
    dataSource: "数据来源",
    dataSourceDesc:
      "您在本站看到的个人资料与优惠券等资讯，由饭团Ricepon 安全提供。",
    privacySecurity: "隐私安全",
    privacySecurityDesc:
      "我们与 饭团Ricepon 共同严格守护您的数据安全，仅用于为您提供本服务。",
    smsCodeError: "短信验证码错误",
    memberLoginErrorTooMany: "会员登录错误次数太多,请稍后重试!",
    accountSuspended: "账户已暂停，请联络客户服务email!",
    accountExpired: "账户已过期，请联络客户服务email!",
    phoneNumberLabel: "电话号码",
    passwordLabel: "密码",
    enterPhoneNumber: "请输入电话号码",
    enterVerificationCode: "请输入验证码",
    enterCorrectPhone: "请输入正确的手机号",
    captchaLabel: "验证码",
    sendVerifyCode: "取得验证码",
    resendVerifyCode: "重新取得验证码",
    sendCodeFailed: "发送验证码失败",
    pleaseSendVerificationCode: "请点送验证码",
    verificationCodeFormatError: "验证码格式错误",
    verificationPassed: "通过校验",
    googleBindTitle: "绑定 Google 账号",
    googleBindSubtitle: "麻烦你先绑定一次，之后就可以直接用 Google 登录，不用再收短信验证码。",
    googleBindAccountName: "Google 账号",
    googleBindAccountLinked: "Google 账号已关联",
    googleBindWithSms: "短信绑定",
    googleBindWithPassword: "密码绑定",
    googleBindPasswordLabel: "密码",
    googleBindPasswordPlaceholder: "请输入密码",
    googleBindHelpTitle: "需要帮助？",
    googleBindHelpText:
      "如果你已设置密码，可直接使用密码绑定；如果未注册或未设置密码，也可以使用短信方式完成注册或绑定。",
    googleBindExpired: "Google 绑定已失效，请重新登录 Google",
    googleBindInvalidPhone: "请输入正确的手机号",
    googleBindPasswordRequired: "请输入密码",
    googleBindFailed: "Google 绑定失败",
    googleBindPasswordFailed: "密码绑定失败",
    googleBindSuccess: "绑定成功",
    googleBindContinue: "继续",
    googleBindBusy: "操作过于频繁，请稍后再试",
    googleMemberNotFound: "未找到会员资料，请稍后再试",
    googleAccountAlreadyBound: "该 Google 账号已绑定其他账号",
    googleMemberAlreadyBoundOther: "该会员已绑定另一个 Google 账号",
    googleLoginFailed: "Google 登录失败",
    googleLoginFailedRetry: "Google 登录失败，请改用密码或短信登录",
    googleLoginUnavailable: "Google 登录暂时不可用",
    googleOpenInBrowser: "当前页面所在浏览器不支持 Google 登录，请点击右上角用系统浏览器打开后再试",
    googleNeedAgree: "请先同意条款",
    googleAgreeAndContinue: "需要先同意条款，是否同意并继续 Google 登录？",
    googleAgreeAndContinuePrefix: "是否同意",
    googleAgreeAndContinueSuffix: "并继续 Google 登录？",
    googleClientIdTip: "配置 VUE_APP_GOOGLE_CLIENT_ID 后即可使用 Google 登录。",
  googleRecommended: "推荐使用 Google 登录",
  googleRecommendedDesc: "无需等待短信，登录和绑定会更快完成。",
    googleButtonLabel: "使用 Google 账号登录",
    googleConfirmTitle: "Google登录/注册",
    googleConfirmSubtitle: "同意协议并使用Google授权登录",
    googleConfirmCancel: "再想想",
    googleConfirmAgree: "我同意",
    googleAltLogin: "或使用短信登录",
    googleLoading: "正在加载 Google 登录…",
    googleRedirecting: "正在跳转到 Google…",
    bindMobileDescription: "使用WhatsApp快速登录",
    unregisteredAutoRegister: "未注册手机号将自动创建账号",
    smsLoginLabel: "短信登录",
    passwordLoginLabel: "密码登录",
    loginActionText: "登录",
    whatsappVerifyLogin: "WhatsApp 验证登录",
    safeAuthTip: "快速、安全、一键授权",
    passwordSafeTip: "使用密码安全登录",
    switchOtherMethods: "或切换其他方式",
    forgotPasswordLabel: "忘记密码?",
    pasteOtpConfirm: "是否粘贴{code}?",
    nextStep: "下一步",
  },
  payPopup: {
    RefreshPaymentResult: "刷新支付结果",
    Paying: "正在支付",
    "Submitted, please wait patiently": "订单已提交,请您耐心等候",
    Cancelled: "取消支付",
    "Cancellation failed": "取消失败",
    Paid: "订单已支付",
  },
  map: {
    "Please enable location permission in browser settings":
      "请在浏览器设置中打开定位用以定位",
    "The request for location was denied.": "用户拒绝对获取地理位置的请求。",
    "Location is unavailable.": "位置信息是不可用的。",
    "The request for location timed out.": "请求用户地理位置超时。",
    "Unknown error.": "未知错误。",
    "Current browser does not support getting location":
      "该浏览器不支持获取地理位置",
    View_Google_Navigation: "查看Google导航",
  },
  area: {
    HongKong: "中国香港",
    Singapore: "新加坡",
    Macau: "中国澳门",
    China: "中国大陆",
    Japan: "日本",
    Korea: "韩国",
    Thailand: "泰国",
  },
  invite: {
    submitted: "已提交",
    "Merchant has confirmed": "商户已确认",
    "Meal available": "可以取餐",
    Tel: "收货电话",
    "Please wait patiently for the merchant to confirm, and pick up the meal according to the meal code. If the meal code is not displayed, please try to refresh":
      "请耐心等待商家确定，凭取餐码取餐，如取餐码未显示请尝试刷新",
    "Contact merchant": "联络餐厅", //联系商家
    Cancelled: "已取消",
    "Subscribe to notification messages using WhatsApp":
      "是否跳转 WhatsApp 完成跳转",
  },
  confirm: {
    Warm_prompt: "温馨提示",
    cap_Confirm: "确认",
  },
  account: {
    昵称: "昵称",
    修改昵称: "修改昵称",
    请输入昵称: "请输入昵称",
    邮件: "邮件",
    修改邮件: "修改邮件",
    请输入邮件: "请输入邮件",
    请输入正确的邮件地址: "请输入正确的邮件地址",
    生日: "生日",
    修改生日: "修改生日",
    修改成功: "修改成功",
    温馨提示: "温馨提示",
    品牌协议: "品牌协议",
    切换语言: "切换语言",
    登出: "登出",
    登入: "登入",
    请先登入: "请先登入~",
    切换字体: "切换字体",
  },
  tabBar: {
    首页: "首页",
    点单: "点单",
    订单: "订单",
    账户: "账户",
  },
  tabBarBrand: "品牌",
  pay: {
    支付金额应大于0: "支付金额应大于0",
  },
  order: {
    更多: "更多...",
    共X份: "共{x}份,总金额: {n}",
    取消订单: "取消订单",
    申请退款: "申请退款",
    联络餐厅: "联络餐厅",
    去支付: "去支付",
    退款进度: "退款进度：",
    取消原因: "取消原因：",
    堂食: "堂食",
    外送: "外送",
    自取: "自取",
    冷冻派送: "冷冻派送",
    待支付: "待支付",
    已提交: "已提交",
    待确认: "待确认",
    製作中: "制作中",
    待取餐: "待取餐",
    已完成: "已完成",
    已取消: "已取消",
    外卖自取: "外卖自取",
    取餐信息: "取餐信息",
    评价: "评价",
    订单码: "订单码",
    投票: "投票",
    投票历史: "投票历史",
    商家已确认不可取消: "商家已确认，不可取消",
    取消成功: "取消成功!",
    确定取消订单: "确定取消订单?",
    等待确认: "等待确认",
    等待付款: "等待付款",
    订单已完成: "订单已完成",
    待取餐: "待取餐",
    派送中: "派送中",
    已送达: "已送达",
    退款处理中: "退款处理中",
    预计5到7天内退款完成: "预计5-7天内退款完成",
    预计1到3个工作日内退款完成: "预计1-3个工作日内退款完成",
    退款已完成: "退款已完成",
    退款中: "退款中",
    外卖订单: "外卖订单",
    店铺订单: "店铺订单",
    扫码点餐: "扫码点餐",
    已完结: "已完结",
    已取餐: "已取餐",
    购买等级: "购买等级",
    已取餐: "已取餐",
    團購券: "团购券",
    可使用: "可使用",
  },
  orderList: {
    all: "全部",
    pendingPayment: "待付款",
    toBeEvaluatedOrVoted: "点评/投票",
    loading: "加载中...",
    empty: "暂时没有订单",
  },
  barcode: {
    可前往埋單機掃賬單碼支付訂單: "可前往埋单机扫描账单码支付订单",
    點擊查看賬單碼: "点击查看账单码",
    請到埋單機掃下方賬單碼支付訂單: "请到埋单机扫描下方账单码支付订单",
    賬單碼: "账单码",
  },
  couponTag: {
    減: "减",
    OFF: "OFF",
  },
  mealFood: {
    加购享优惠: "加购享优惠",
    撞餐優惠金額結賬時進行計算: "撞餐优惠券金额结账时进行计算",
  },
  queue: {
    暂不支持X取号: "暂不支持 {X} 等级取号!",
    取号记录: "取号记录",
    还需等待x桌: "还需等待{X}桌",
    排队中: "轮候中",
    呼叫中: "呼叫中",
    已过号: "已过号",
    已入座: "已入座",
    已取消: "已取消",
    请耐心等候: "请稍候片刻，我们马上为您安排!",
    请与餐厅职员联络:
      "不好意思，餐厅已暂停取号服务。如有疑问，请与餐厅职员联络。",
    优先轮候: "优先轮候",
    普通会员: "普通会员",
    X优先取票: "“{X}”优先取票",
    您的会员等级不足: "您的会员等级不足",
    仅支持X优先轮候: "仅支持{X}优先轮候",
    知道了: "关闭",
    温馨提示: "温馨提示",
    超出限制: "您在当前餐厅轮候号码已超过限制 请前往取消后再试",
    已取过号了: "你已经在{X}餐厅取号轮候 是否取消此餐厅的轮候？",
    再想想: "再想想",
    取消排队: "取消轮候",
    请选择用餐时段: "请选择用餐时段",
    取消成功: "取消成功",
    网络似乎开小差了: "网络似乎开小差了，请稍后再试!",
    补票中: "补票中",
    未齐人号码保留中: "保留中",
    餐厅优惠: "餐厅优惠",
    更多: "更多",
    公告: "公告",
    请输入用餐人数: "请输入用餐人数",
    请输入会员Id: "请输入美高梅会员号码",
    取号成功: "取号成功",
    请通过以下方式获取排队进度提醒: "请选择以下获取轮候状态方式",
    请选择以下获取排队提醒方式: "请选择以下获取轮候提醒方式",
    微信通知: "微信通知",
    获取短信提醒: "获取短信提醒",
    请输入你要获取排队动态的电话号码:
      "请输入你希望用于接收轮候状态提醒的手机号码。",
    确定: "确 定",
    请输入正确的手机号: "请输入正确的手机号",
    微信订阅成功: "微信订阅成功",
    微信订阅失败: "微信订阅失败",
    短信订阅成功: "短信订阅成功",
    短信订阅失败: "短信订阅失败",
    跳过: "跳过",
    获取排队通知: "避免错过入座时机,请获取轮候通知",
    餐厅地址: "餐厅地址",
    餐厅名称: "餐厅名称",
    用餐人数: "用餐人数",
    取号时间: "取号时间",
    X人: "{X}人",
    联络电话: "联络电话",
    用餐号: "用餐号",
    是否确认取消轮候: "是否确认取消轮候？",
    MGM_确认取消: "确认取消",
    MGM_否: "否",
    X人: "{X}人",
    X人以上: "{X}人以上",
    X到Y人: "{X}~{Y}人",
    点击这里以短讯接收通知: "点击这里以短讯接收通知",
    接收短讯可能产生电讯商费用: "(接收短讯可能产生电讯商费用)",
    获取提醒表示接受X: "获取提醒表示接受《{X}》",
    私隐条款: "私隐条款",
  },
  WhatsApp: {
    感谢惠顾: "感谢惠顾",
    X为你送上Y张优惠券: "{X}为你送上 {Y} 张优惠券",
    前往领取: "前往领取",
  },
};
export default zh;





